import Navigation from "./Navigation";
import Footer from "./Footer";

export function LegalSection({ title, children }) {
  return (
    <section className="border-t border-white/[0.08] pt-8">
      <h2 className="font-display text-2xl tracking-tight mb-4">{title}</h2>
      <div className="space-y-4 text-zinc-400 leading-relaxed">{children}</div>
    </section>
  );
}

export default function LegalLayout({ eyebrow, title, updated, intro, children }) {
  return (
    <>
      <Navigation />
      <main className="relative z-10 min-h-screen px-5 sm:px-8 lg:px-12 pt-36 sm:pt-44 pb-28">
        <div className="max-w-3xl mx-auto">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-6 block">{eyebrow}</span>
          <h1 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] tracking-tighter mb-6">{title}</h1>
          {updated && <p className="text-zinc-500 text-sm mb-8">Dernière mise à jour : {updated}</p>}
          {intro && <p className="text-zinc-300 leading-relaxed mb-12">{intro}</p>}
          <div className="space-y-10">{children}</div>
        </div>
      </main>
      <Footer />
    </>
  );
}
